<template>
    <el-dialog @close="close" style="margin-left: 52%;overflow: inherit;overflow-y: scroll" :visible.sync="dialogVisible" width="98%">
        <!--标题显示-->
        <div class="title">
            <div @click="handlerSwitchClick(item)" class="btns"
                 :class="item.exportType === selectRow.exportType ? 'active' : ''" v-for="(item, index) in switchBtn"
                 :key="index">
                {{ item.name }}
            </div>
        </div>
        <div class="container2" style="background-color: rgba(232,232,232,0.3);padding: 10px">
            <p class="p1">请维护您在方案后会带出的共性内容 (前端word导出后，及小程序导出前可修改)</p>
            <p class="p2">
                报价说明版本: <span class="span1">（点击名称查看展示效果)</span>
                <el-button size="mini" @click="handlerAddScheme" class="p3">新增说明版本</el-button>
            </p>
            <!--方案列表-->
            <div class="priceSm">
                <div class="priceSmText" v-for="(item, index) in schemeList" :key="index">
                    <!--选中某个方案说明-->
                    <p @click="handlerSelectedScheme(item)" :class="selectedScheme && selectedScheme.id === item.id ? 'active2' : ''"
                       class="p4">{{ item.schemeName }}</p>
                    <svg-icon @click="handlerSchemeEdit(item)" class="svg" iconClass="edit"></svg-icon>
                    <el-popconfirm title="删除该方案内容,对于方案的合同内也会连带删除,您确认要进行此操作吗？"
                                   @confirm="handlerSchemeDelete(item)">
                        <svg-icon slot="reference" class="svg" iconClass="delete"></svg-icon>
                    </el-popconfirm>
                </div>
            </div>
            <!--方案内描述展示-->
            <div class="box-card">
                <!--循环内容-->
                <div class="line1" v-for="(item, keys) in btnList" :key="keys">
                    <!--左侧数据-->
                    <div class="left">
                        <p class="p5" style="width: 1.5rem">{{ item.title }}</p>
                        <div @click="handlerAddBtnClick(keys, item)" v-if="item.flag" class="btns">
                            <span style="color: red; margin-right: 0.05rem">+</span>
                            <span>加项</span>
                        </div>
                    </div>
                    <!--右侧数据-->
                    <draggable style="background-color: white;padding: 10px;border-radius: 10px" class="right"  @start="onStart($event,keys)" @end="onEnd($event,keys)" animation="300" v-model="item.arr" group="draggableTitle">
                        <div v-for="(item1, index1) in item.arr" :key="index1" class="draggableTitle">
                            <div class="btns draggableTitle" :class="selectedTitle.budgetTitle === item1.budgetTitle && selectedTitle.budgetDescType === Number(keys) ? 'active1': ''" @click="handlerSelectBtnClick(item1)">
                                {{ item1.budgetTitle }}
                                <i class="el-icon-delete" @click="delByDesc(item1.id)"></i>
                                <img v-if="item1.budgetTitleContent.length > 0" class="checkIcon" :src="require('@/assets/png/btnRight.png')" alt=""/>
                            </div>
                        </div>
                    </draggable>
                </div>
            </div>
            <div style="display: flex;justify-content: center;margin-top: 20px">
                <el-button type="primary" style="width: 400px" @click="combinationSchemeDescription">我已生成好选项，开始组合方案说明</el-button>
            </div>
        </div>
        <!--新增方案说明弹框-->
        <el-dialog :visible.sync="schemeVisible" width="30%" append-to-body @close="close" style="margin-left: 500px">
            <el-form label-position="top" style="margin-top: 20px">
                <el-input v-model="selectSchemeRow.schemeName" placeholder="请填写方案说明名称？"></el-input>
            </el-form>
            <div style="margin-top: 10px;text-align: right">
                <el-button type="primary" @click="addScheme">提交</el-button>
                <el-button @click="schemeVisible = false">取消</el-button>
            </div>
        </el-dialog>
        <!--方案维护项添加或者修改-->
        <el-dialog :visible.sync="schemeTitleVisible" width="30%" append-to-body @close="close" style="margin-left: 500px">
            <el-form label-position="top" style="margin-top: 20px">
                <el-input v-model="selectTitleRow.budgetTitle" placeholder="请填写方案说明标题名称？"></el-input>
            </el-form>
            <div style="margin-top: 10px;text-align: right">
                <el-button type="primary" @click="addSchemeTitle">提交</el-button>
                <el-button @click="schemeTitleVisible = false">取消</el-button>
            </div>
        </el-dialog>
        <!--方案说明标题项添加弹框-->
        <offerDetailPopup :readonly="false" ref="offerDetailPopupBtn" @emitSave="emitSave"></offerDetailPopup>
        <!--方案说明详情页组合弹框-->
        <offerDetailPopup :show-button="false" ref="offerDetailPopupCombination"></offerDetailPopup>
    </el-dialog>
</template>
<script>
import PlanApi from "@/components/Api/PlanApi";
import offerDetailPopup from "@/views/mechanism/components/offerDetailPopup.vue";
import draggable from 'vuedraggable';
import {compare} from "@/util/arrayGroup";
import Ueditor from "@/components/Editor/Ueditor.vue";
import Tinymce from "@/components/Tinymce.vue";
export default {
    components: {Ueditor, draggable, offerDetailPopup,Tinymce},
    data() {
        return {
            // 初始化传递的数据
            optionsData: "",
            dialogVisible: false,
            // 新增方案版本弹款控制
            schemeVisible: false,
            // 新增方案版本提交参数
            selectSchemeRow: {},
            // 标题索引
            current: 0,
            // 标题项
            switchBtn: [
                {
                    exportType: 0,
                    name: "报价说明"
                },
                {
                    exportType: 1,
                    name: "确认单说明"
                },
                {
                    exportType: 2,
                    name: "出团说明"
                }
            ],
            // 与后台交互数据
            selectRow: {
                // 0 报价说明 1 确认单说明 2 出团说明
                exportType: 0
            },
            // 公司内所有的方案说明信息
            schemeList: [],
            // 所选中的方案说明
            selectedScheme: {id: -1},
            // 方案说明维护项
            btnList: {
                1: {
                    flag: true,
                    title: "常规",
                    arr: [],
                },
                2: {
                    flag: true,
                    title: "服务标准说明",
                    arr: [],
                },
                3: {
                    flag: true,
                    title: "行程外活动的安排",
                    arr: [],
                },
                4: {
                    flag: true,
                    title: "参团与安全风险提示",
                    arr: [],
                },
                5: {
                    flag: true,
                    title: "购物补充说明",
                    arr: [],
                },
                6: {
                    flag: true,
                    title: "自费项目补充确认",
                    arr: [],
                },
                7: {
                    flag: true,
                    title: "其他",
                    arr: [],
                },
            },
            // 方案说明标题操作项
            selectTitleRow: {},
            schemeTitleVisible: false,
            // 选中的标题
            selectedTitle: {}
        }
    },
    computed: {
        computedTitleList() {
            return function (budgetDescType) {
                console.log("computedTitleList",this.selectedScheme)
                if (this.selectedScheme && this.selectedScheme.budgetDescs && this.selectedScheme.budgetDescs.length > 0) {
                    let arr = this.selectedScheme.budgetDescs.filter(x => x.budgetDescType === budgetDescType)
                    return arr.sort(compare("sort"))
                } else {
                    return []
                }
            }
        }
    },
    methods: {
        delByDesc(id) {
            new PlanApi("plan").delDescById(id).then((res) => {
                if (res.status === 200) {
                    this.$message.success("删除成功！")
                    this.queryByCompany()
                } else {
                    this.$message({type: "error", message: res.statusText});
                }
            });
        },
        combinationSchemeDescription() {
            this.$refs.offerDetailPopupCombination.init(this.selectedScheme.htmlContentStr)
            this.$refs.offerDetailPopupBtn.close()
        },
        emitSave(data) {
            this.selectedTitle.budgetTitleContent = data
            new PlanApi("plan").updateDescById(this.selectedTitle).then((res) => {
                if (res.status === 200) {
                    this.$message.success("保存成功！")
                    new PlanApi("plan").saveOrUpdateQuoted(this.selectedScheme).then(res => {
                        if (res.status === 200) {
                            // 更新方案数据
                            this.queryByCompany()
                        }
                    })
                } else {
                    this.$message({type: "error", message: res.statusText});
                }
            });
        },
        // 初始化弹框
        init(data) {
            this.optionsData = data
            this.dialogVisible = true
            this.queryByCompany()
        },
        // 标题点击事件
        handlerSwitchClick(item) {
            this.selectRow.exportType = item.exportType
            this.queryByCompany()
        },
        // 查询公司内的方案信息
        queryByCompany() {
            new PlanApi("plan").queryByCompanyId(this.selectRow.exportType).then((res) => {
                if (res.status === 200) {
                    this.schemeList = res.data;
                    let find = this.schemeList.find(x => x.id === this.selectedScheme.id)
                    if (find) {
                        this.$set(this,"selectedScheme",find)
                    } else {
                        this.selectedScheme = this.schemeList[0]
                    }
                    this.selectedScheme.show = true
                    this.setBtnArr(this.selectedScheme)
                    console.log("this.selectedScheme.htmlContentStr",this.selectedScheme.htmlContentStr)
                    this.$refs.offerDetailPopupCombination.init(this.selectedScheme.htmlContentStr)
                } else {
                    this.$message({type: "error", message: res.statusText});
                }
            });
        },
        // 新增版本说明
        handlerAddScheme() {
            this.schemeVisible = true
        },
        close() {
        },
        // 添加方案说明
        addScheme() {
            this.selectSchemeRow.exportType = this.selectRow.exportType
            new PlanApi("plan").saveOrUpdateQuoted(this.selectSchemeRow).then(res => {
                if (res.status === 200) {
                    this.$message.success("添加成功！")
                    this.queryByCompany()
                    this.schemeVisible = false
                } else {
                    this.$message.error(res.statusText)
                }
            })
        },
        // 选中方案说明
        handlerSelectedScheme(selectSchemeItem) {
            for (let btnListKey in this.btnList) {
                this.btnList[btnListKey].arr = []
            }
            // 1 调出左侧渲染框数据
            // this.$refs.offerDetailPopup.init(selectSchemeItem.htmlContentStr)
            // 2 设置选中的内容
            this.setBtnArr(selectSchemeItem)
            console.log("this.btnList",this.btnList)
            this.$forceUpdate()

        },

        setBtnArr(selectSchemeItem) {
            this.selectedScheme = selectSchemeItem
            if (this.selectedScheme.budgetDescs && this.selectedScheme.budgetDescs.length > 0) {
                for (let btnListKey in this.btnList) {
                    let dataList = this.selectedScheme.budgetDescs.filter(x => x.budgetDescType === Number(btnListKey))
                    console.log("dataList",dataList,btnListKey,this.selectedScheme.budgetDescs)
                    if (dataList && dataList.length > 0) {
                        // this.btnList[btnListKey].arr = dataList.sort.compare("sort")
                        this.$set(this.btnList[btnListKey],"arr",dataList.sort(compare("sort")))
                    }
                }
            }
            this.$refs.offerDetailPopupCombination.close()
            this.$refs.offerDetailPopupBtn.close()
        },
        // 方案说明编辑
        handlerSchemeEdit(selectSchemeItem) {
            this.selectedScheme = selectSchemeItem
        },
        // 方案说明删除
        handlerSchemeDelete(selectSchemeItem) {
            new PlanApi("plan").schemeDelById(selectSchemeItem.id).then(res => {
                if (res.status === 200) {
                    this.$message.success("删除成功！")
                    this.queryByCompany()
                } else {
                    this.$message.error(res.statusText)
                }
            })
        },
        // 方案加项
        handlerAddBtnClick(keys, item) {
            if (!this.selectedScheme) {
                this.$message.error("请先选中说明版本！")
                return
            }
            this.selectTitleRow.budgetDescType = keys
            this.selectTitleRow.schemeId = this.selectedScheme.id
            this.schemeTitleVisible = true
            this.queryByCompany()
        },
        addSchemeTitle() {
            new PlanApi("plan").savaOrUpdateDesc(this.selectTitleRow).then(res => {
                if (res.status === 200) {
                    this.$message.success("添加成功！")
                    this.queryByCompany()
                    this.schemeTitleVisible = false
                } else {
                    this.$message.error(res.statusText)
                }
            })
        },
        // 选项标题选中
        handlerSelectBtnClick(item1) {
            this.selectedTitle = item1
            this.selectedScheme.show = true
            this.$refs.offerDetailPopupBtn.init(item1.budgetTitleContent)
            // this.$refs.ueditor.setUeContent(item1.budgetTitleContent)
            // this.$refs.ueditor.dataHeardSplicing(item1.)
        },
        // 拖拽开始
        onStart(e,keys) {
            console.log("拖拽开始",e,keys)
        },
        // 拖拽结束
        onEnd(e, keys) {
            console.log("拖拽结束",this.btnList)
            let arr = []
            for (let btnListKey in this.btnList) {
                this.btnList[btnListKey].arr.forEach(item => {
                    item.budgetDescType = btnListKey
                })
                for (let i = 0; i < this.btnList[btnListKey].arr.length; i++) {
                    this.btnList[btnListKey].arr[i].sort = i
                    arr.push(this.btnList[btnListKey].arr[i])
                }
            }
            new PlanApi("plan").dragAndDropModification(arr).then((res) => {
                if (res.status === 200) {
                    this.queryByCompany()
                } else {
                    this.$message({type: "error", message: res.statusText});
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>

.title {
    padding-top: 0.2rem;
    display: flex;
    align-items: center;
    margin-bottom: 0.24rem;

    .btns {
        width: 50%;
        height: 0.4rem;
        border: 1px solid #ed7046;
        background-color: #fff;
        color: #000;
        line-height: 0.4rem;
        text-align: center;
        cursor: pointer;

        &:nth-child(even) {
            border-right: none;
            border-left: none;
        }
    }
}

.active {
    background-color: #ed7046 !important;
    color: #fff !important;
}

.active2 {
    color: #ed7046 !important;
}

.active1 {
    background-color: #fbe6ba;
}

.container2 {
    .box-card {
        color: #8c8d90 !important;

        .line {
            height: 1px;
            border-bottom: 1px solid #e8e8e8;
            margin-bottom: 0.24rem;
        }

        .line1 {
            display: flex;
            align-items: center;
            margin-bottom: 0.24rem;

            .p5 {
                font-size: 0.12rem;
                width: 2rem;
            }

            .left {
                .btns {
                    width: 0.6rem;
                    font-size: 0.12rem;
                    background-color: #ffe5b4;
                    padding: 2px 3px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    border-radius: 5px;

                    &:hover {
                        color: red !important;
                    }
                }
            }

            .right {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                width: 100%;

                .btns {
                    display: inline-block;
                    min-width: 0.72rem;
                    // height: 0.3rem;
                    // text-align: center;
                    line-height: 0.3rem;
                    padding: 0px 5px;
                    border: 1px solid #fbe6ba;
                    margin-left: 0.1rem;
                    cursor: pointer;
                    position: relative;
                    margin-bottom: 0.1rem;

                    .checkIcon {
                        display: inline-block;
                        width: 12px;
                        height: 12px;
                        background-size: contain;
                        background-repeat: no-repeat;
                        position: absolute;
                        bottom: 0;
                        right: 0;
                    }
                }
            }
        }

        .centerBox {
            min-height: 3rem;
            position: sticky;
            top: 0px;
            //border: 1px solid rgba(0, 0, 0, 0.09);

            .centerBoxTitle {
                height: 0.3rem;
                color: #ff6637;
                line-height: 0.3rem;
                padding-left: 0.2rem;
                font-size: 0.12rem;
                border-bottom: 1px solid #e8e8e8;
            }

            .centerBoxBottom {
                padding-left: 0.2rem;
                padding-bottom: 0.24rem;

                .p6 {
                    font-size: 0.12rem;
                    color: #606266;
                    margin-bottom: 0.1rem;
                }
            }
        }

        .footerBox {
            .p7 {
                color: #7a7b7f;
                font-size: 0.12rem;

                span {
                    color: #000;
                    border-bottom: 1px solid #000;
                    cursor: pointer;
                    margin-right: 0.12rem;
                }
            }
        }

        /*如果需要隐藏滚动条样式 则在标签上 加上 class = hiddenScrollbar*/
        .myUeditor {
            /deep/ .edui-editor {
                position: sticky;
                top: 0;
                height: 410px;
                overflow: scroll;
            }

            /deep/ .edui-editor-toolbarbox {
                position: sticky;
                top: 0;
                z-index: 9999;
            }

            /deep/ .ueditor-box {
            }
        }

        .footerBottomBtns {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;

            .bnts1 {
                border: 1px solid rgb(255, 102, 55);
                color: rgb(255, 102, 55);
                border-radius: 0.1rem;
                width: 1rem;
            }

            .btns2 {
                border: 1px solid rgb(255, 102, 55);
                color: #fff;
                border-radius: 0.1rem;
                background-color: rgb(255, 102, 55);
                width: 1rem;
            }
        }
    }

    .p1 {
        font-size: 0.12rem;
        color: rgb(2, 160, 198);
        font-weight: 400;
        margin-bottom: 0.12rem;
    }

    .p2 {
        color: #606266;
        font-size: 0.16rem;
        display: flex;
        align-items: center;
        margin-right: 0.24rem;
        width: 55%;
        margin-bottom: 0.12rem;

        .span1 {
            font-size: 0.12rem;
            font-family: "\9ED1\4F53";
        }

        .p3 {
            margin-left: auto;
            color: #dd7751;
            cursor: pointer;
        }
    }

    .priceSm {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 0.2rem;

        .priceSmText {
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-right: 0.1rem;

            .p4 {
                font-size: 0.12rem;
                font-family: "\9ED1\4F53";
                color: #606266;
                margin-right: 0.06rem;
                border-bottom: 1px solid #ed7045;
            }

            .svg {
                color: #ed7045;
            }

            .el-icon-close {
                background-color: #ed6f47;
                color: #fff;
                font-size: 0.2rem;
                margin-left: 0.05rem;
            }
        }
    }
}
</style>